import { render, staticRenderFns } from "./ExportRoutes.vue?vue&type=template&id=6e484e70&scoped=true&"
import script from "./ExportRoutes.vue?vue&type=script&lang=js&"
export * from "./ExportRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e484e70",
  null
  
)

export default component.exports